"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const general_1 = require("../../../general");
const utils_1 = require("../../layout/user-profile/utils");
const styles_1 = require("./styles");
var Environment;
(function (Environment) {
    Environment[Environment["USER_MANAGEMENT"] = 0] = "USER_MANAGEMENT";
    Environment[Environment["PENSION_FUND_COCKPIT"] = 1] = "PENSION_FUND_COCKPIT";
    Environment[Environment["EMPLOYER_PORTAL"] = 2] = "EMPLOYER_PORTAL";
})(Environment = exports.Environment || (exports.Environment = {}));
const ProfileUserEnvironmentLinks = ({ environmentListProps, currentEnvironment, }) => {
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledUserProfileChangingEnvironment, { "data-testid": "user-profile-changing-environment", fullWidth: true, alignItems: "flex-start", gap: "12px", children: [(0, jsx_runtime_1.jsx)(general_1.Typography, { variant: "body", size: "tiny", weight: "medium", gutterBottom: "16px", colorScheme: {
                    type: 'text',
                    color: 'label',
                }, children: "Changing environment" }), environmentListProps === null || environmentListProps === void 0 ? void 0 : environmentListProps.map(({ value, label, onClick, disabled, hidden }, key) => {
                if (hidden)
                    return null;
                return ((0, jsx_runtime_1.jsxs)(styles_1.StyledApplicationListItem, { role: "button", "aria-roledescription": `go to ${label} application`, fullWidth: true, gap: "8px", "data-testid": `user-profile-list`, current: currentEnvironment === value, onClick: !disabled ? onClick : undefined, ...{ disabled }, children: [(0, jsx_runtime_1.jsx)(utils_1.RenderIcon, { ...{ value } }), (0, jsx_runtime_1.jsx)(general_1.Typography, { variant: "body", size: "normal", weight: "medium", children: label })] }, key));
            })] }));
};
exports.default = ProfileUserEnvironmentLinks;
//# sourceMappingURL=profile-user-envinroment-links.js.map